/**
 * Device detection utilities
 */

const ua = navigator.userAgent.toLowerCase();

/**
 * Check if device is iPad (including iPadOS 13+)
 */
export const isIPad = /ipad/.test(ua) || (ua.includes('mac') && navigator.maxTouchPoints > 1);

/**
 * Check if device is iPhone/iPod
 */
export const isIPhone = /iphone|ipod/.test(ua);

/**
 * Check if device is Android tablet (no "mobile" in UA)
 */
export const isAndroidTablet = /android/.test(ua) && !/mobile/.test(ua);

/**
 * Check if device is Android phone
 */
export const isAndroidPhone = /android/.test(ua) && /mobile/.test(ua);

/**
 * Check if device is any tablet (iPad or Android tablet)
 */
export const isTablet = isIPad || isAndroidTablet;

/**
 * Check if device is any mobile phone (iPhone or Android phone)
 */
export const isMobile = isIPhone || isAndroidPhone;

/**
 * Check if device is tablet or mobile (touch device that needs PDF.js)
 */
export const isTouchDevice = isTablet || isMobile || 
  (('ontouchstart' in window || navigator.maxTouchPoints > 0) && window.innerWidth <= 768);
